import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  meta: {
    title: '明细账单查询',
    auth: true,
    authorityValue: "store-store-bill-logs"
  },
  name: 'billDetail',
  data: function data() {
    return {
      toSearch: [{
        label: '下单日期',
        value: 'orderTimeRange',
        type: 'd2TimeSelect'
      }, {
        label: '订单编号',
        value: 'orderNo',
        type: 'd2Input'
      }, {
        label: '商品编码',
        value: 'goodsNo',
        type: 'd2Input'
      }, {
        label: '结算状态',
        value: 'settledStatus',
        type: 'd2Select',
        children: [{
          label: '待结算',
          value: 1
        }, {
          label: '已结算',
          value: 2
        }]
      }, {
        label: '出库日期',
        value: 'deliveryTimeRange',
        type: 'd2TimeSelect'
      }, {
        label: '订单状态',
        value: 'orderStatus',
        type: 'd2Select',
        children: [{
          label: '已取消',
          value: 8
        }, {
          label: '已出库',
          value: 3
        }, {
          label: '已完成',
          value: 5
        }]
      }],
      toSearch2: [{
        label: '下单日期',
        value: 'orderTimeRange',
        type: 'd2TimeSelect'
      }, {
        label: '退款日期',
        value: 'refundTimeRange',
        type: 'd2TimeSelect'
      }, {
        label: '结算日期',
        value: 'settledTimeRange',
        type: 'd2TimeSelect'
      }, {
        label: '服务单号',
        value: 'refundNo',
        type: 'd2Input'
      }, {
        label: '订单编号',
        value: 'orderNo',
        type: 'd2Input'
      }, {
        label: '结算状态',
        value: 'settledStatus',
        type: 'd2Select',
        children: [{
          label: '待结算',
          value: 1
        }, {
          label: '已结算',
          value: 2
        }]
      }],
      total: 0,
      page: 1,
      limit: 10,
      orderDetails: [],
      orderDetails2: [],
      activeName: 'first',
      extraData: {},
      records: [],
      records2: [],
      seachObj: {},
      seachObj2: {}
    };
  },
  filters: {
    goodsItemList: function goodsItemList(e) {
      try {
        var arr = e.map(function (a) {
          return a;
        });
        var params = [];
        params = arr.map(function (c) {
          var attrs = c.itemSellAttributes.map(function (d) {
            return d.itemValue;
          }).join(',');
          return c.goodsName + '/' + attrs;
        });
        return params.join('、');
      } catch (err) {}
    },
    goodsNo: function goodsNo(val) {
      return val.map(function (v) {
        return v.goodsNo;
      })[0];
    }
  },
  methods: {
    handleSearch: function handleSearch(e) {
      this.seachObj = e;
      this.dataBind(e);
      this.page = 1;
    },
    handleSearch2: function handleSearch2(e) {
      this.seachObj2 = e;
      this.dataBind(e);
      this.page = 1;
    },
    handleReset: function handleReset(e) {
      this.seachObj = {};
      this.seachObj2 = {};
      this.dataBind({
        type: e
      });
    },
    pagination: function pagination(item) {
      this.dataBind(item);
    },
    pagination2: function pagination2(item) {
      console.log(item);
      this.dataBind(item);
    },
    handleClick: function handleClick(tab) {
      this.page = 1;
      this.total = 0;
      this.limit = 10;
      this.dataBind({
        pageNo: this.page,
        pageSize: this.limit
      });
    },
    resetForm: function resetForm() {},
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this$$api$bil, records, total, extraData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.billList(_objectSpread(_objectSpread({}, item), {}, {
                  type: _this.activeName == 'first' ? '1' : '2'
                }));

              case 2:
                _yield$_this$$api$bil = _context.sent;
                records = _yield$_this$$api$bil.records;
                total = _yield$_this$$api$bil.total;
                extraData = _yield$_this$$api$bil.extraData;
                _this.total = total;
                _this.extraData = extraData;
                _this.orderDetails = records;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    download: function download() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$_this2$$api$bi, records, columns, data, arr;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.$api.billList(_objectSpread(_objectSpread({}, _this2.seachObj), {}, {
                  pageSize: 99999,
                  type: 1
                }));

              case 2:
                _yield$_this2$$api$bi = _context3.sent;
                records = _yield$_this2$$api$bi.records;
                _this2.records = records;
                columns = [{
                  label: '订单编号',
                  prop: 'orderNo'
                }, {
                  label: '订单状态',
                  prop: 'orderStatus'
                }, {
                  label: '下单时间',
                  prop: 'orderTime'
                }, {
                  label: '出库时间',
                  prop: 'deliveryTime'
                }, {
                  label: '完成时间',
                  prop: 'completeTime'
                }, {
                  label: '商品编号',
                  prop: 'goodsNo'
                }, {
                  label: '商品名称',
                  prop: 'goodsName'
                }, {
                  label: '商品数量',
                  prop: 'goodsCount'
                }, {
                  label: '佣金比例',
                  prop: 'balancePay'
                }, {
                  label: '费用名称',
                  prop: 'feeName'
                }, {
                  label: '应结金额',
                  prop: 'money'
                }, {
                  label: '收支方向',
                  prop: 'direction'
                }, {
                  label: '结算状态',
                  prop: 'settledStatus'
                }, {
                  label: '结算时间',
                  prop: 'settledTime'
                }];
                data = [];
                _context3.next = 9;
                return _this2.records.forEach( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(v) {
                    var goodsParams, goodsRow, commissionRow, cashbackRow, orderStatusStr;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            goodsParams = {};
                            v.goodsItemList.forEach(function (e) {
                              goodsParams = _objectSpread({}, e);
                            });
                            goodsRow = {};
                            commissionRow = {};
                            cashbackRow = {};
                            orderStatusStr = _this2.dict.orderStatus.filter(function (e) {
                              return e.value == v.orderStatus;
                            });

                            _this2.$set(v, 'orderStatus', orderStatusStr[0].label);

                            if (v.goodsAmount > 0) {
                              goodsRow = _objectSpread(_objectSpread({}, v), goodsParams);

                              _this2.$set(goodsRow, 'feeName', '货款');

                              _this2.$set(goodsRow, 'money', v.goodsAmount);

                              _this2.$set(goodsRow, 'direction', '收入');

                              _this2.$set(goodsRow, 'settledStatus', v.goodsAmountSettled ? '已结算' : '未结算');

                              _this2.$set(goodsRow, 'settledTime', v.goodsAmountSettlementTime);
                            }

                            if (v.commissionAmount > 0) {
                              commissionRow = _objectSpread(_objectSpread({}, v), goodsParams);

                              _this2.$set(commissionRow, 'feeName', '佣金');

                              _this2.$set(commissionRow, 'money', v.commissionAmount);

                              _this2.$set(commissionRow, 'direction', '支出');

                              _this2.$set(commissionRow, 'settledStatus', v.commissionSettled ? '已结算' : '未结算');

                              _this2.$set(commissionRow, 'settledTime', v.commissionSettlementTime);
                            }

                            if (v.cashbackAmount > 0) {
                              cashbackRow = _objectSpread(_objectSpread({}, v), goodsParams); // this.$set(cashbackRow,'feeName','返现')

                              _this2.$set(cashbackRow, 'money', v.cashbackAmount);

                              _this2.$set(cashbackRow, 'direction', '支出');

                              _this2.$set(cashbackRow, 'settledStatus', v.cashbackSettled ? '已结算' : '未结算');

                              _this2.$set(cashbackRow, 'settledTime', v.cashbackSettlementTime);
                            }

                            data.push(goodsRow);
                            data.push(commissionRow);
                            data.push(cashbackRow);

                          case 13:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 9:
                arr = data.filter(function (e) {
                  return JSON.stringify(e) !== '{}';
                });

                _this2.xlsxExport(columns, arr, '订单对账');

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    download2: function download2() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _yield$_this3$$api$bi, records, columns, data, arr;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this3.$api.billList(_objectSpread(_objectSpread({}, _this3.seachObj2), {}, {
                  pageSize: 99999,
                  type: 2
                }));

              case 2:
                _yield$_this3$$api$bi = _context5.sent;
                records = _yield$_this3$$api$bi.records;
                _this3.records2 = records;
                columns = [{
                  label: '服务单号',
                  prop: 'refundNo'
                }, {
                  label: '订单编号',
                  prop: 'orderNo'
                }, {
                  label: '下单时间',
                  prop: 'payTime'
                }, {
                  label: '退款时间',
                  prop: 'checkedTime'
                }, {
                  label: '商品编号',
                  prop: 'goodsNo'
                }, {
                  label: '商品名称',
                  prop: 'goodsName'
                }, {
                  label: '商品数量',
                  prop: 'goodsCount'
                }, {
                  label: '费用名称',
                  prop: 'feeName'
                }, {
                  label: '应结金额',
                  prop: 'money'
                }, {
                  label: '收支方向',
                  prop: 'direction'
                }, {
                  label: '结算状态',
                  prop: 'settledStatus'
                }, {
                  label: '结算时间',
                  prop: 'settledTime'
                }];
                data = [];
                _context5.next = 9;
                return _this3.records2.forEach( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(v) {
                    var goodsParams, goodsRow, commissionRow, cashbackRow, orderStatusStr;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            goodsParams = {};
                            v.goodsItemList.forEach(function (e) {
                              goodsParams = _objectSpread({}, e);
                            });
                            goodsRow = {};
                            commissionRow = {};
                            cashbackRow = {};
                            orderStatusStr = _this3.dict.orderStatus.filter(function (e) {
                              return e.value == v.orderStatus;
                            });

                            _this3.$set(v, 'orderStatus', orderStatusStr[0].label);

                            if (v.refundAmount > 0) {
                              goodsRow = _objectSpread(_objectSpread({}, v), goodsParams);

                              _this3.$set(goodsRow, 'feeName', '货款');

                              _this3.$set(goodsRow, 'money', v.refundAmount);

                              _this3.$set(goodsRow, 'direction', '支出');

                              _this3.$set(goodsRow, 'settledStatus', v.goodsAmountSettled ? '已结算' : '未结算');

                              _this3.$set(goodsRow, 'settledTime', v.goodsAmountSettlementTime);
                            }

                            if (v.commissionAmount > 0) {
                              commissionRow = _objectSpread(_objectSpread({}, v), goodsParams);

                              _this3.$set(commissionRow, 'feeName', '佣金');

                              _this3.$set(commissionRow, 'money', v.commissionAmount);

                              _this3.$set(commissionRow, 'direction', '收入');

                              _this3.$set(commissionRow, 'settledStatus', v.commissionSettled ? '已结算' : '未结算');

                              _this3.$set(commissionRow, 'settledTime', v.commissionSettlementTime);
                            }

                            if (v.cashbackAmount > 0) {
                              cashbackRow = _objectSpread(_objectSpread({}, v), goodsParams); // this.$set(cashbackRow,'feeName','返现')

                              _this3.$set(cashbackRow, 'money', v.cashbackAmount);

                              _this3.$set(cashbackRow, 'direction', '支出收入');

                              _this3.$set(cashbackRow, 'settledStatus', v.cashbackSettled ? '已结算' : '未结算');

                              _this3.$set(cashbackRow, 'settledTime', v.cashbackSettlementTime);
                            }

                            data.push(goodsRow);
                            data.push(commissionRow);
                            data.push(cashbackRow);

                          case 13:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 9:
                arr = data.filter(function (e) {
                  return JSON.stringify(e) !== '{}';
                });

                _this3.xlsxExport(columns, arr, '退款单对账');

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  },
  created: function created() {
    this.dataBind();
  }
};